// Generated types for SysMLNamespace
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from './sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from './sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLNamespaceReadAPI extends SysMLElementReadAPI {
}

export interface SysMLNamespaceWriteAPI extends SysMLElementWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLNamespaceReadAPISchema: z.ZodType<SysMLNamespaceReadAPI> = SysMLElementReadAPISchemaObject.extend({}).passthrough();

export const SysMLNamespaceWriteAPISchema: z.ZodType<SysMLNamespaceWriteAPI> = SysMLElementWriteAPISchemaObject.extend({}).passthrough();
